import { render, staticRenderFns } from "./ImageField.vue?vue&type=template&id=3b3bcd42&scoped=true&"
import script from "./ImageField.vue?vue&type=script&lang=js&"
export * from "./ImageField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3bcd42",
  null
  
)

export default component.exports